export interface Token {
  token: string;
}

export class TokenValue implements Token{
  token: string;
  constructor(token:string){
    this.token=token;
  } 
}